import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";
import { api } from "../lib/api";

const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/find-battery", label: "Find Battery", id: "find" },
  { to: "/products", label: "Products", id: "products" },
  { to: "/about", label: "About", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    api.get("/logo").then(r => setLogo(r.data?.logo)).catch(() => {});
  }, []);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-black/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          {logo ? (
            <img src={logo} alt="Bharat Battery House" className="h-11 w-11 md:h-12 md:w-12 object-contain rounded-full ring-1 ring-black/10 bg-white" />
          ) : (
            <img src="https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/f661huv0_logo.jpg" alt="BBH Bharat Battery House" className="h-11 w-11 md:h-12 md:w-12 object-contain rounded-full ring-1 ring-black/10 bg-white" />
          )}
          <div className="flex flex-col leading-none">
            <span className="font-display font-black text-base md:text-lg tracking-tight">BHARAT BATTERY HOUSE</span>
            <span className="text-[10px] uppercase tracking-[0.24em] text-secondary/90">Amaron Battery Solutions</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map(n => (
            <NavLink
              key={n.id}
              to={n.to}
              data-testid={`nav-${n.id === "find" ? "find-battery" : n.id}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-secondary" : "text-foreground/80 hover:text-foreground"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <a
            href="tel:+919549390000"
            data-testid="nav-call-btn"
            className="ml-2 px-5 py-2 rounded-full bg-primary text-black font-semibold text-sm hover:bg-secondary hover:text-white transition-colors"
          >
            Call Now
          </a>
        </nav>

        <button
          onClick={() => setOpen(v => !v)}
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 rounded-md border border-black/10"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-white">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV.map(n => (
              <NavLink
                key={n.id}
                to={n.to}
                data-testid={`nav-mobile-${n.id}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium ${isActive ? "bg-primary/10 text-secondary" : "text-foreground/80"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a href="tel:+919549390000" data-testid="nav-mobile-call-btn" className="mt-2 px-4 py-3 rounded-full bg-primary text-primary-foreground font-semibold text-center">
              Call Now — +91 95493 90000
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
